import React, { Component } from 'react';
import Calculator from '../components/calculator';



class App extends Component{
    constructor(props) {
        super(props);
        this.state = {
            moreDetailsVisible: false,
            re: /\S+@\S+\.\S+/, // Regular expression for validate input type email
            reDate: /^([0-2][0-9]|3[0-1])(\/|-)(0[1-9]|1[0-2])\2(\d{4})$/, // Regular expression for validate input type date dd/mm/yyyy
            items:{
                value: '',
                rate: 0.6,
                name: '',
                phone: '',
                email: '',
                paymentDate: '',
                dateInDays: '',
                dateShort: '00/00/00',
                advancePercentage: 85,
                mesfixCommission: 1,
                costPSE: 17850,
                custodyInvoices: 30000,
                ivaComMsfx: 0,
                totalCosts: 0,
                comissionMsfxIva: 0,
                totalCX1000: 0,
                costFNGIVA: 0,
                transactionalCost: this.formatNumber(17850 + 30000),
                netAdvance: 0,
                rateFng: 0.0295,
                totalOperation: 0,
                documentNumber: ''
            },
            completeData: false,
            btnMoreDetailsVisible: true,
            messageEmailSended: false,
            spinnerVisible: false,
            detailsCostVisible: true,
            inputValid: true,
            placeholderNit: '0/9'
        };
    }
    // Function initial
    componentDidMount = () =>{
        let paymentDate = document.getElementById("paymentDate");
        var self = this;
        paymentDate.addEventListener("select", function (){
            self.setState({
                items: {
                    ...self.state.items,
                    paymentDate: paymentDate.value,
                    dateInDays: self.timeIndays(paymentDate.value),
                    dateShort: self.dateShort(paymentDate.value)
                }
            },() =>{
                self.calculateFinancing()
            });
        })
        
    }
    // Get date in days
    timeIndays(paymentDate){
        if (paymentDate == null) {
            return "vacio"
        }
        let dateSepate = paymentDate.split('/')
        // Get date in milliseconds
        let dateMilliseconds = new Date(dateSepate[2], dateSepate[1] - 1, dateSepate[0]).getTime();
        // Get today in milliseconds
        let todayMilliseconds = new Date().getTime();
        // Difference between todayMilliseconds and dateMilliseconds 
        let differenceTime = dateMilliseconds - todayMilliseconds;
        let timeInDays = Math.ceil((differenceTime) / (1000 * 60 * 60 * 24));
        return timeInDays;
    }
    // Change input
    handleChange = (event) =>{
        let name = event.target.name;
        let value = event.target.value;
        
        if(name === 'value'){
            value = this.inputToNumber(event.target.value);
            event.target.value = this.formatNumberOffer(value)
        }
        else if(name === 'name'){
            value = this.inputToText(event.target.value);
            event.target.value = value;
        }
        else if(name === 'phone'){
            value = this.inputToNumber(event.target.value);
            event.target.value = value;
        }
        else if(name === 'paymentDate'){
            value = this.inputToNumberDate(event.target.value);
            event.target.value = value;
            this.setState({
                items: {
                    ...this.state.items,
                    dateShort: this.dateShort(event.target.value)
                }
            })
        }
        else if(name === 'documentNumber'){
            value = this.inputToNumber(event.target.value);
            event.target.value = value;
            this.setState({
                inputValid: value.length < 8 ? false : true,
                placeholderNit: this.calculatePlaceHolder(value)
            });
        }

        this.setState({
            items: {
                ...this.state.items,
                [name]: value
            }
        },()=>{
            this.calculateFinancing()
        });
    }
    // Calculate value of placeholder
    calculatePlaceHolder(value) {
        var actualLength = value.length;
        var placeholderValue = this.state.placeholderNit;
        var splitValue = placeholderValue.split("/");

        splitValue[0] = actualLength

        return splitValue.toString().replace(",", "/")

    }
    // Get date short
    dateShort(paymentDate){
        let dateShort = paymentDate.slice(0,6) + paymentDate.slice(-2)
        return dateShort
    }
    // Enable save simulation button
    saveSimulationBtn = () =>{
        let enable = true;

        if(this.state.items.value === ''){
            enable = false
        }
        else if(this.state.items.paymentDate === '' || this.state.items.paymentDate === '00/00/0000' || this.state.items.paymentDate.length < 10){
            enable = false
        }
        else if(!this.state.reDate.test(this.state.items.paymentDate) || this.state.items.dateInDays < 0){
            enable = false
        }
        return enable

    }
    // Calculate financing
    calculateFinancing(){
        let value = this.state.items.value === '' ? 0 : this.state.items.value;
        value = parseInt(value.toString().replace(/\./g, ""))
        // Pay date of invoice
        let dueDays = this.state.items.dateInDays === '' ? 0 : this.state.items.dateInDays
        // Calculates the gross advance (anticipo bruto)
        let grossAdvance = value * (this.state.items.advancePercentage / 100);
        // Calculates Mesfix commission with iva
        var valComMsfx = (this.state.items.mesfixCommission / 100) * value;
        let ivaComMsfx = valComMsfx * 0.19;
        // Get 4x1000 of Gross advance
        let cX1000Advance = grossAdvance * (4 / 1000);
        // Get 4x1000 of invoice value
        let cX1000Payment = value * (4 / 1000);
        let operationCost = this.state.items.costPSE + cX1000Advance + cX1000Payment + valComMsfx + ivaComMsfx + this.state.items.custodyInvoices;
        // Calculates the net advance (anticipo neto)
        let netAdvance = grossAdvance - operationCost;
        // Set up of the rates to calculate the interest
        let dailyRate = (Math.pow((1 + this.state.items.rate / 100), (1 / 30))) - 1;
        let invInterest = value * (Math.pow(1 + dailyRate, dueDays)) - value;
        let customerPay = value - netAdvance - operationCost - invInterest;
        // Calculates the other details and the remaining values
        let totalCX1000 = cX1000Advance + cX1000Payment;
        let comissionMsfxIva = valComMsfx + ivaComMsfx;
        let costFNGIVA = ((((value * this.state.items.rateFng) / 12) * (Math.ceil(dueDays / 30)))* 1.19)
        //Calculates all the costs that are going to be shown
        let totalCosts = this.state.items.costPSE + cX1000Advance + cX1000Payment + valComMsfx + ivaComMsfx + this.state.items.custodyInvoices + invInterest + parseInt(costFNGIVA);
        let totalOperation = netAdvance + customerPay
        this.setState({
            items: {
                ...this.state.items,
                totalCosts: this.formatNumber(Math.round(totalCosts)),
                comissionMsfxIva: this.formatNumber(Math.round(comissionMsfxIva)),
                totalCX1000: this.formatNumber(Math.round(totalCX1000)),
                netAdvance: netAdvance < 0 ? 0 : this.formatNumber(Math.round(netAdvance)),
                customerPay: this.formatNumber(Math.round(customerPay)),
                costFNGIVA: this.formatNumber(Math.round(costFNGIVA)),
                totalOperation: totalOperation < 0 ? 0 : this.formatNumber(Math.round(totalOperation))
            }
        })
    }
    // Validate input Number
    inputToNumber(inputText){
        return (((inputText||"").toString().replace(/[^0-9]/g, ""))||"");
    }
    // Validate input date
    inputToNumberDate(inputText){
        return (((inputText||"").toString().replace(/[^0-9/]/g, ""))||"");
    }
    // Validate input text
    inputToText(inputText){
        return (((inputText||"").toString().replace(/[^a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]/g, ""))||"");
    }
    // Thousands format no zero
    formatNumberOffer = (total) =>{
        return (total||"" ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    // Thousands format
    formatNumber = (total) =>{
        return (total||"" || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    moreDetails = () =>{
        this.setState({
            moreDetailsVisible: this.state.moreDetailsVisible ? false : true,
            detailsCostVisible: this.state.detailsCostVisible ? false : true
        })
    }
    // Save simulation button
    saveSimulation = () =>{
        this.setState({
            completeData: true,
            moreDetailsVisible: true,
            btnMoreDetailsVisible: false,
            detailsCostVisible: false
        });
    }
    // Edit simulation
    editSimulation = () =>{
        this.setState({
            completeData: false,
            moreDetailsVisible: false,
            btnMoreDetailsVisible: true,
            detailsCostVisible: true,
            items: {
                ...this.state.items,
                name: '',
                phone: '',
                email: ''
            }
        });
        
    }
    // Validate form
    validateForm = () =>{
        let validate = true;
        let captchaElement = document.getElementById('g-recaptcha-response').value;

        if((this.state.items.documentNumber === '') || (this.state.items.documentNumber.length < 8)){
            validate = false
        }
        else if(this.state.items.name === ''){
            validate = false
        }
        else if(this.state.items.email === ''){
            validate = false
        }
        else if(!this.state.re.test(this.state.items.email )){
            validate = false
        }
        else if(!captchaElement || captchaElement === null || captchaElement === undefined){
            validate = false
        }
        return validate

    }
    // Send simulation
    sendSimulation = () =>{

        if(!this.state.spinnerVisible){
            this.setState({
                spinnerVisible: true
            })

            let formData = new FormData();
            let dataToSend = ['value','netAdvance','customerPay','advancePercentage',
                        'totalCosts','comissionMsfxIva','transactionalCost','totalCX1000',
                        'costFNGIVA','paymentDate','rate','documentNumber','name','email',
                        'phone']

            let self = this;
            dataToSend.map(function(key){
                return formData.append(key, self.state.items[key])
            });


            
            // Send captcha
            let captchaElement = document.getElementById('g-recaptcha-response').value;
            formData.append('g-recaptcha-response', captchaElement);

            fetch('/ms/general/calculatorEmpForm.json', {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            }).then(res => res.json())
              .then(
                (result) => {
                    if(result.status === 200){
                        this.setState({
                            messageEmailSended: true,
                            spinnerVisible: false
                        });
                    }
                    else{
                        this.setState({
                            spinnerVisible: false
                        });
                    }
                },
                (error) => {
                }
            )
        }
    }
    // Reset calculator
    resetCalculator = () =>{
        this.setState({
            messageEmailSended: false,
            completeData: false,
            btnMoreDetailsVisible: true,
            moreDetailsVisible: false,
            detailsCostVisible: true,
            items: {
                ...this.state.items,
                value: '',
                totalOperation: 0,
                netAdvance: 0,
                advancePercentage: 85,
                totalCosts: 0,
                comissionMsfxIva: 0,
                transactionalCost: this.formatNumber(17850 + 30000),
                totalCX1000: 0,
                costFNGIVA: 0,
                paymentDate: '',
                rate: 0.6,
                documentNumber: '',
                name: '',
                email: '',
                phone: ''
            }
        });
        document.getElementById('paymentDate').value = '';
        
        this.refValue.value = '';
        
    }
    render(){
        return (
          <Calculator moreDetails={this.moreDetails}
           moreDetailsVisible={this.state.moreDetailsVisible} items={this.state.items}
           handleChange={this.handleChange} saveSimulationBtn={this.saveSimulationBtn}
           completeData={this.state.completeData} saveSimulation={this.saveSimulation}
           editSimulation={this.editSimulation} btnMoreDetailsVisible={this.state.btnMoreDetailsVisible}
           validateForm={this.validateForm} formatNumber={this.formatNumber}
           sendSimulation={this.sendSimulation} messageEmailSended={this.state.messageEmailSended}
           resetCalculator={this.resetCalculator} refValue={el => this.refValue = el}
           spinnerVisible={this.state.spinnerVisible} click={this.click}
           detailsCostVisible={this.state.detailsCostVisible} inputValid={this.state.inputValid}
           placeholderNit={this.state.placeholderNit}>
           </Calculator>
        );
    }
}

export default App;